(function () {
  let swiperProductCard;

  const initSlider = (section) => {
    if (!section || !section?.classList.contains("section-product-card-slider"))
      return;
    
    console.log('Initializing product card slider for section:', section.id);
    
    // Destroy existing slider if it exists
    if (swiperProductCard) {
      console.log('Destroying existing slider');
      swiperProductCard.destroy(true, true);
      swiperProductCard = null;
    }
    
    const swiperProductCardEl = section.querySelector(
      ".product-card-slider__swiper"
    );

    const pagination = section.querySelector(
      ".product-card-slider__pagination"
    );

    if (!swiperProductCardEl) {
      console.warn('Swiper element not found in section:', section.id);
      return;
    }

    console.log('Found swiper element:', swiperProductCardEl);

    // Check if Swiper is available globally
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper not loaded, retrying in 100ms...');
      setTimeout(() => initSlider(section), 100);
      return;
    }

    const autoplaySettings = swiperProductCardEl.dataset.swiperAutoplay
      ? JSON.parse(swiperProductCardEl.dataset.swiperAutoplay)
      : false;

    try {
      swiperProductCard = new Swiper(swiperProductCardEl, {
        autoplay:
          autoplaySettings !== 0
            ? {
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                delay: autoplaySettings,
              }
            : false,
        loop: Boolean(autoplaySettings),
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 16,
        allowTouchMove: true,
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: pagination ?? null,
          clickable: true,
        },
        on: {
          init: function () {
            // Add swiper-initialized class for CSS
            swiperProductCardEl.classList.add('swiper-initialized');
            console.log('Product card slider initialized successfully with swiper-initialized class');
          },
          destroy: function () {
            // Remove swiper-initialized class
            swiperProductCardEl.classList.remove('swiper-initialized');
            console.log('Product card slider destroyed, removed swiper-initialized class');
          }
        }
      });
      
      console.log('Product card slider initialized successfully');
    } catch (error) {
      console.error('Error initializing product card slider:', error);
    }
  };

  const animateSection = (section) => {
    if (
      !section ||
      !section?.classList.contains("section-product-card-slider") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const animateContainer = (imageContainer) => {
      ScrollTrigger.create({
        trigger: imageContainer,
        start: "50% 90%",
        end: "bottom top",
        onEnter: () => imageContainer.classList.add("animated"),
      });
    };

    const animateHeading = (heading) => {
      ScrollTrigger.create({
        trigger: heading,
        start: "bottom 95%",
        end: "bottom top",
        onEnter: () => heading.classList.add("animated"),
      });
    };

    const cardsLayoutImageContainer = section.querySelector(
      ".product-card-slider__layout[data-layout-type='cards']"
    );

    if (cardsLayoutImageContainer) {
      animateContainer(cardsLayoutImageContainer);
    }

    const overlayLayoutImageContainer = section.querySelector(
      ".product-card-slider__media-solid"
    );

    if (overlayLayoutImageContainer) {
      animateContainer(overlayLayoutImageContainer);
    }

    const heading = section.querySelector(".product-card-slider__heading");

    if (heading) {
      animateHeading(heading);
    }
  };

  document.addEventListener(
    "DOMContentLoaded",
    initSlider(document.currentScript?.parentElement)
  );

  document.addEventListener(
    "DOMContentLoaded",
    animateSection(document.currentScript?.parentElement)
  );

  // Variant Picker Functionality (both original and custom)
  const initVariantPickers = (section) => {
    if (!section || !section?.classList.contains("section-product-card-slider"))
      return;

         // Handle original product variant dropdowns
     const originalVariantDropdowns = section.querySelectorAll('.variant-dropdown');
     originalVariantDropdowns.forEach(dropdown => {
       const variantSelect = dropdown.querySelector('.variant-select');
       const productCard = dropdown.closest('.card-wrapper');
       const variantInput = productCard.querySelector('.variant-id-input');
       const form = productCard.querySelector('form');
       
       if (variantSelect && form) {
         variantSelect.addEventListener('change', function() {
           // Find the selected variant ID from the option's data attribute
           const selectedValue = this.value;
           const selectedOption = this.options[this.selectedIndex];
           
           if (selectedOption && selectedOption.dataset.variantId && variantInput) {
             // Update the variant ID in the form
             variantInput.value = selectedOption.dataset.variantId;
             console.log('Original variant selected:', selectedValue, 'Variant ID:', selectedOption.dataset.variantId);
           }
         });
       }
     });

    // Handle custom metafield-based variant buttons
    const customVariantPickers = section.querySelectorAll('.custom-variant-picker');
    
    customVariantPickers.forEach(picker => {
      const variantOptions = picker.querySelectorAll('.variant-option');
      const productCard = picker.closest('.card-wrapper');
      const variantInput = productCard.querySelector('.variant-id-input');
      const productIdInput = productCard.querySelector('.product-id-input');
      const priceElement = productCard.querySelector('.price');
      const titleElement = productCard.querySelector('.card__title a');
      const form = productCard.querySelector('form');
      
      variantOptions.forEach(option => {
        option.addEventListener('click', function() {
          // Remove selected class from all options
          variantOptions.forEach(opt => opt.classList.remove('variant-option--selected'));
          
          // Add selected class to clicked option
          this.classList.add('variant-option--selected');
          
          // Update the variant ID in the form
          if (variantInput) {
            variantInput.value = this.dataset.variantId;
          }
          
          // Update the product ID in the form
          if (productIdInput) {
            productIdInput.value = this.dataset.variantProductId;
          }
          
          // Update price if available
          if (priceElement && this.dataset.variantPrice) {
            const currentPrice = priceElement.querySelector('.price__regular .price-item--regular');
            if (currentPrice) {
              currentPrice.textContent = this.dataset.variantPrice;
            }
          }
          
          // Update title if available
          if (titleElement && this.dataset.variantTitle) {
            titleElement.textContent = this.dataset.variantTitle;
          }
          
          // Store the selected variant data for form submission
          if (form) {
            form.dataset.selectedVariantId = this.dataset.variantId;
            form.dataset.selectedProductId = this.dataset.variantProductId;
            form.dataset.selectedVariantTitle = this.dataset.variantTitle;
            
            console.log('Switched to custom variant:', this.dataset.variantTitle, 'Product ID:', this.dataset.variantProductId);
          }
        });
      });
      
      // Handle form submission for custom variants
      if (form) {
        form.addEventListener('submit', function(e) {
          const selectedVariantId = this.dataset.selectedVariantId;
          const selectedProductId = this.dataset.selectedProductId;
          
          // If a custom variant is selected, handle the submission
          if (selectedVariantId && selectedProductId) {
            e.preventDefault();
            
            // Add the selected variant to cart using Shopify's cart API
            const formData = new FormData();
            formData.append('id', selectedVariantId);
            formData.append('quantity', '1');
            
            fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => {
              if (data.status === 422) {
                // Handle error
                console.error('Error adding to cart:', data.description);
                // You can show an error message to the user here
              } else {
                // Success - trigger cart update
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
                
                // Show success message or trigger cart drawer
                console.log('Added to cart:', data);
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        });
      }
    });
  };

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
    animateSection(event.target);
    initVariantPickers(event.target);
  });

  // Initialize variant pickers on DOM ready
  document.addEventListener("DOMContentLoaded", function() {
    const sections = document.querySelectorAll('.section-product-card-slider');
    sections.forEach(section => {
      initVariantPickers(section);
    });
  });
})();
